<!--  -->
<template>
  <div>
    <el-form label-position="right" label-width="110px" :model="addform">
      <el-form-item label="群好友">
        <el-tag v-for="items,index in addform.corp_user" :key="index" style="margin-right:10px" closable @close="handleClose(items.external_user_id,index)">{{ items.nickname }} </el-tag>
        <el-button type="warning" size="mini" @click="laren">好友</el-button>
      </el-form-item>
      <el-form-item label="企业联系人">
        <el-tag v-for="items,index in addform.official_account" :key="index" style="margin-right:10px" closable @close="handleCloseacc(items.app_id,index)">{{ items.name }} </el-tag>
        <el-button type="warning" size="mini" @click="chorwer">企业联系人</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="dawer">确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="拉人"
      :visible.sync="dialogVisiblepeo"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="50%"
    >
      <!-- :destroy-on-close="true" -->
      <uplist ref="uplistview" @bandarr="uplistdata" />
    </el-dialog>
    <el-dialog
      title="选择人员"
      :visible.sync="dialogVisibleaccr"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="50%"
    >
      <!-- :destroy-on-close="true" -->
      <bandaccount ref="bandaccountview" @bandarr="bandarrview" />
    </el-dialog>
  </div>
</template>

<script>
import uplist from './uplist.vue'
import bandaccount from './bandaccount.vue'
import { invitationMemberToChat } from '@/api/officialaccount.js'
export default {
  components: { uplist, bandaccount },
  data() {
    return {
      up_chatroom_id: null,
      group_chat_owner: null,
      dialogVisiblepeo: false,
      dialogVisibleaccr: false,
      addform: {
        corp_user: [],
        official_account: []
      },
      corarr: [],
      offarr: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    sendr(up_chatroom_id, group_chat_owner) {
      this.up_chatroom_id = up_chatroom_id
      this.group_chat_owner = group_chat_owner
    },
    handleClose(id, index) {
      console.log(index)
      this.addform.corp_user.splice(index, 1)
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.uplistview.set(id)
      }, 100)
    },
    handleCloseacc(id, index) {
      console.log(index)
      this.addform.official_account.splice(index, 1)
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.bandaccountview.set(id)
      }, 100)
    },
    laren() {
      this.dialogVisiblepeo = true
      this.$nextTick(() => {
        this.$refs.uplistview.sendr(this.up_chatroom_id, this.addform.corp_user)
      })
    },
    chorwer() {
      this.dialogVisibleaccr = true
      this.$nextTick(() => {
        this.$refs.bandaccountview.sendr(this.up_chatroom_id, this.addform.official_account)
      })
    },
    uplistdata(arr) {
      this.dialogVisiblepeo = false
      this.addform.corp_user = arr
    },
    async dawer() {
      if (this.addform.corp_user.length === 0) {
        this.$message.error('请选择要绑定的好友')
        return
      }
      if (this.addform.official_account.length === 0) {
        this.$message.error('请选择要绑定的企业联系人')
        return
      }
      this.corarr = []
      this.offarr = []
      this.corarr = this.addform.corp_user.map((item) => {
        return item.external_user_id
      })
      this.offarr = this.addform.official_account.map((item) => {
        return item.employee_no
      })
      const data = await invitationMemberToChat({
        group_chat_owner: this.group_chat_owner,
        up_chatroom_id: this.up_chatroom_id,
        external_user_ids: this.corarr,
        employee_nos: this.offarr
      })
      this.$emit('updata')
      console.log('data', data)
    },
    bandarrview(arr) {
      this.dialogVisibleaccr = false
      this.addform.official_account = arr
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
